var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagPostBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1886_174835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 14.0007V5.33398C2.6665 4.80355 2.87722 4.29484 3.25229 3.91977C3.62736 3.5447 4.13607 3.33398 4.6665 3.33398H11.3332C11.8636 3.33398 12.3723 3.5447 12.7474 3.91977C13.1225 4.29484 13.3332 4.80355 13.3332 5.33398V9.33398C13.3332 9.86442 13.1225 10.3731 12.7474 10.7482C12.3723 11.1233 11.8636 11.334 11.3332 11.334H5.33317L2.6665 14.0007Z",
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.33398V7.34065",
    stroke: "black",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 7.33398V7.34065",
    stroke: "black",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 7.33398V7.34065",
    stroke: "black",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1886_174835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagPostBlack);
export default __webpack_public_path__ + "static/media/icon_search_tag_post_black.cce508bdb63a34d3df7376c6771d9766.svg";
export { ForwardRef as ReactComponent };